import { motion } from "framer-motion";

// Masked line-by-line reveal. IMPORTANT: the IntersectionObserver (whileInView)
// must sit on the OUTER, non-clipped element. The inner element is translated
// out of an overflow:hidden mask, so observing it directly reports 0 visibility
// and the reveal would never fire. We drive the inner span via variants instead.
export const MaskLine = ({ children, delay = 0, className = "", load = false }) => {
  const trigger = load
    ? { animate: "visible" }
    : { whileInView: "visible", viewport: { once: true, amount: 0.35 } };
  return (
    <motion.span className="line-mask" initial="hidden" {...trigger}>
      <motion.span
        className={`block ${className}`}
        variants={{ hidden: { y: "110%" }, visible: { y: "0%" } }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
      >
        {children}
      </motion.span>
    </motion.span>
  );
};

// Fade + rise for blocks
export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay }}
  >
    {children}
  </motion.div>
);
